import { useTranslation } from 'react-i18next'

import { getBirdviewCardBodyContent } from '../BirdviewCard.utils'

import * as styles from './BirdviewCardBody.module.css'

function BirdviewCardBody({ children, state, onRetry }) {
  const { t } = useTranslation()

  return (
    <div className={styles.body}>
      {getBirdviewCardBodyContent({ children, state, t, onRetry })}
    </div>
  )
}

export default BirdviewCardBody
